'use client';

import { useCallback } from 'react';

import Link from 'next/link';

import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { FieldLabels } from '@shared/types/enums/fieldLabels.enum';
import { Button } from '@shared/ui/Button';
import { CloseIcon } from '@shared/ui/CloseIcon';
import { Input } from '@shared/ui/Input';
import { Modal } from '@shared/ui/Modal';

import { changeName, changePhone, closeCallModal, sendData } from '../model/slice/callModalSlice';
import cls from './CallModal.module.scss';

export const CallModal = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector((state) => state.callModal.openModal);
  const name = useAppSelector((state) => state.callModal.name);
  const phone = useAppSelector((state) => state.callModal.phone);
  const errors = useAppSelector((state) => state.callModal.errors);
  const loading = useAppSelector((state) => state.callModal.loading);

  const changeNameHandler = useCallback(
    (value: string) => {
      dispatch(changeName(value));
    },
    [dispatch]
  );

  const changePhoneHandler = useCallback(
    (value: string) => {
      dispatch(changePhone(value));
    },
    [dispatch]
  );

  const sendDataHandler = () => {
    dispatch(sendData());
  };

  const onCloseHandler = () => {
    dispatch(closeCallModal());
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCloseHandler}
    >
      <div
        data-testid={'callModal'}
        className={cls.content}
      >
        <div className={cls.top}>
          <div className={cls.title}>Перезвоните мне</div>

          <CloseIcon
            testId={'callModal-close-button'}
            onClick={onCloseHandler}
          />
        </div>
        <div className={cls.text}>Наш сотрудник свяжется с вами в ближайшее, либо установленное вами время</div>
        <div
          role={'form'}
          aria-label={'Форма на заявку на звонок'}
        >
          <div className={cls.row}>
            <Input
              testId="callModal-form-name"
              value={name}
              onChange={changeNameHandler}
              isError={errors.name}
              label={FieldLabels.FIRST_NAME}
            />
            <Input
              testId="callModal-form-phone"
              phoneMask
              value={phone}
              onChange={changePhoneHandler}
              isError={errors.phone}
              label={FieldLabels.PHONE_NUMBER}
            />
          </div>
          <Button
            loadingButton
            isLoading={loading}
            aria-label={'Отправить заявку'}
            testId={'callModal-form-button'}
            onClick={sendDataHandler}
            size={'l'}
            className={cls.send}
          >
            Заказать звонок
          </Button>
          <div className={cls.policy}>
            Нажимая “Заказать звонок”, я даю согласие на{' '}
            <Link
              target={'_blank'}
              href={ROUTES.PERSONAL_DATA}
            >
              обработку персональных данных
            </Link>{' '}
          </div>
        </div>
      </div>
    </Modal>
  );
};
